import "./SegmentedControl.css";

/*
  SegmentedControl Component

  A short set of mutually exclusive choices shown side by side (language
  switch, reply / internal note, ...). Each option is a toggle button with
  aria-pressed, inside a labelled group.

  options  [{ value, label, disabled? }]
  value    the selected option's value
  onChange called with the new value
  label    accessible name of the group
  size     sm / md
  fullWidth stretch to the container (options share the width)
*/

const SegmentedControl = ({ options = [], value, onChange, label, size = "md", fullWidth = false, disabled = false, className = "" }) => (
  <div className={`ui-segmented ${size} ${fullWidth ? "full" : ""} ${className}`} role="group" aria-label={label}>
    {options.map((option) => (
      <button
        key={option.value}
        type="button"
        aria-pressed={option.value === value}
        disabled={disabled || option.disabled}
        onClick={() => option.value !== value && onChange?.(option.value)}
      >
        {option.label}
      </button>
    ))}
  </div>
);

export default SegmentedControl;
